import { FC } from 'react';
import { Link } from 'react-router';

export const Footer: FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-layout border-t border-border py-2.5 md:py-3 lg:py-3.5 px-4 md:px-6 lg:px-8 xl:px-10 transition-colors duration-300 fixed bottom-0 left-0 right-0 z-50 h-[4rem]">
      {/* Footer container */}
      <div className="mx-auto flex flex-col md:flex-row justify-center md:justify-between items-center gap-2 md:gap-0 text-xs md:text-sm lg:text-base text-text-secondary">
        {/* Copyright section */}
        <div className="text-center md:text-left">
          © {currentYear} AXL Systems. All Rights Reserved.
        </div>
        
        {/* Navigation links */}
        <nav className="flex justify-center items-center gap-3 md:gap-4 lg:gap-6">
          <Link
            to="#"
            // to="/privacy-policy"
            className="hover:text-text-primary transition-colors duration-300 touch-manipulation"
          >
            Privacy Policy
          </Link>
          <Link 
            // to="/terms-of-service"
            to="#"
            className="hover:text-text-primary transition-colors duration-300 touch-manipulation"
          >
            Terms of Service
          </Link>
          <Link 
            to="#"
            // to="/contact-us"
            className="hover:text-text-primary transition-colors duration-300 touch-manipulation"
          >
            Contact Us
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;